import React, { FunctionComponent } from 'react';
import Link from 'next/link';
import { EnumerateLogo } from '../Dashboard/Icons';
import ProfileMenu from '../Common/ProfileMenu';
import {
  longFormatPermissionType,
  surveyPermissionsObjType,
  usagePermissionsObjType,
} from '@/store/Reducers/Types';
import { TabType } from './Tabs';
import useCobranding from '@/hooks/useCobranding';
import Colab from '../Common/Colab';
import { useRouter } from 'next/router';
import AccountActions from '../Common/AccountActions';

export type SidebarProps = {
  tabId: string;
  surveyId: number;
  permissions?: any;
  Tabs: TabType[];
};

const Sidebar: FunctionComponent<SidebarProps> = ({
  Tabs,
  tabId,
  surveyId,
  permissions,
}) => {
  const router = useRouter();
  const { isCobranding, brandLogo } = useCobranding();

  const selected = 'rounded bg-link-blue stroke-white fill-white color-white';
  const baseTabClass =
    'box-content flex justify-center mt-2 items-center w-7 h-5 p-3 object-contain stroke-enum-logo transition duration-500 hover:scale-110 cursor-pointer hover:bg-slate-100';
  const checkForPermissions =
    router.pathname !== '/settings' && router.pathname !== '/templates';

  const hasPermission = (tab: TabType) => {
    // The route does not depend on permission
    if (!checkForPermissions) return true;
    else {
      // Route is dependant on permission. If no permission then dont show anything
      if (!permissions) return false;
    }
    // If route is dependant on permission and permission object is loaded then display below tabs with no check
    if (tab.id === 'my-usage') {
      return true;
    }
    // If route is dependant on permission and permission object is loaded then display below tabs only if admin
    if (tab.id === 'clients-data' || tab.id === 'client-management') {
      return permissions['admin'] === true;
    }
    // If no permission required, show the tab
    if (!tab.permission || tab.permission === '') {
      return true;
    }
    // Display rest only depending on permission
    return permissions[tab.permission] === true;
  };

  return (
    <div className="box-border flex w-[72px] flex-col justify-between items-center px-10 border-r border-b-indigo-100">
      <div className="flex flex-col items-center p-2">
        <Link href="/home">
          <div
            className="box-content w-[68px] h-11 border-b border-b-enum-border-color"
            style={{ paddingBottom: '0.2rem', paddingLeft: '1.5rem' }}
          >
            <EnumerateLogo withName={false} />
          </div>
        </Link>
        <div className="mt-2">
          {Tabs.map(
            (tab) =>
              hasPermission(tab) && (
                <Link
                  key={tab.id}
                  href={tab.route(tab.id || '', `${surveyId || ''}`)}
                >
                  <div
                    id={tab.id}
                    className="flex justify-centers flex-col items-center"
                  >
                    <div
                      className={`box-content flex justify-center mt-2 items-center w-7 h-5 p-3 object-contain stroke-enum-logo ${
                        tabId === tab.id
                          ? selected
                          : 'transition duration-500 hover:scale-110 cursor-pointer hover:bg-slate-100'
                      }`}
                    >
                      {tab.Icon(tabId === tab.id ? '#FFFFFF' : '#242424')}
                    </div>
                    <span className="w-full flex px-2 justify-center mt-0 tags-font text-center text-wrap text-primary-black">
                      {tab.text}
                    </span>
                  </div>
                </Link>
              ),
          )}
        </div>
      </div>
      <div className="flex flex-col items-center justify-between space-y-4">
        {isCobranding && <Colab />}
        {/* <ProfileMenu /> */}
        <AccountActions isLarge={false} />
      </div>
    </div>
  );
};

export default Sidebar;
